import { ADMIN_SITE_PREFIX } from "@constants/index";

export const AdminPaths = {
  userManagement: `/${ADMIN_SITE_PREFIX}/user`,
  roundtableManagement: `/${ADMIN_SITE_PREFIX}/roundtable`,
  frontpageManagement: `/${ADMIN_SITE_PREFIX}/frontpage`,
} as const;
